import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Grid, Modal } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { resetTimesheetTimesheetEntriesAPIErrors } from 'services/timesheetTimesheetEntriesAPIErrors/actions';
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import { resetErrorByNamespace } from 'services/error/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Selectors
import {
    selectTimesheetEntriesApiErrorUuids
    // @ts-ignore
} from 'services/timesheetTimesheetEntriesAPIErrors/selectors';
import {
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import TimesheetTimesheetEntriesApiErrorMessages from './components/TimesheetTimesheetEntriesApiErrorMessages';

export interface OwnProps {
    revertRows: Function;
}

interface StateProps {
    isOpen?: boolean;
    uuids?: string[];
}

interface DispatchProps {
    resetTimesheetTimesheetEntriesAPIErrors: Function;
    updateQueryString: Function;
    resetErrorByNamespace: typeof resetErrorByNamespace;
}

type IProps = StateProps & DispatchProps & OwnProps;

export class TimesheetTimesheetEntriesAPIErrorModal extends React.PureComponent<IProps> {
    handleClose = () => {
        this.props.updateQueryString({
            timesheetEntriesErrorModal: undefined
        });
    };

    handleRevert = () => {
        const {
            revertRows,
            uuids,
            resetErrorByNamespace: resetError
        } = this.props;
        revertRows(uuids);
        this.props.resetTimesheetTimesheetEntriesAPIErrors();

        resetError('TIMESHEET_TIMESHEET_ENTRIES_MANAGE');
        this.handleClose();
    };

    render(): React.ReactElement | null {
        const { isOpen, uuids } = this.props;

        if (!uuids || !uuids.length) return null;

        return (
            <Modal
                size="tiny"
                open={isOpen}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="TimesheetTimesheetEntriesErrorModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Saving failed</Modal.Header>
                    <Modal.Content>
                        <TimesheetTimesheetEntriesApiErrorMessages />
                        <p>
                            The affected entries will be reverted back to their
                            last valid state.
                        </p>
                        <p>
                            {
                                'If this results in the loss of a lot of changes, please contact '
                            }
                            <a href="mailto:mail@orchardhand.com">support</a>.
                        </p>
                        <p>
                            {
                                'If you have any ideas about how we could better handle errors, please submit them through the '
                            }
                            <a
                                href="https://ideas.orchardhand.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ideas portal
                            </a>
                            {'.'}
                        </p>
                        <Grid centered>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    onClick={this.handleClose}
                                    fluid
                                    basic
                                    primary
                                >
                                    Ignore
                                </Button>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    primary
                                    onClick={this.handleRevert}
                                    fluid
                                >
                                    Revert
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    isOpen: makeSelectQueryStringBooleanValue('timesheetEntriesErrorModal'),
    uuids: selectTimesheetEntriesApiErrorUuids
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, {
    resetTimesheetTimesheetEntriesAPIErrors,
    updateQueryString,
    resetErrorByNamespace
})(TimesheetTimesheetEntriesAPIErrorModal);
